import { updateObject } from "../utility";

export const toggleRegisterDialog = (state, value) => {
  return updateObject(state, {
    registerDialog: !state.registerDialog,
  });
};

export const toggleProductDetails = (state, value) => {
  return updateObject(state, {
    productDetailsDialog: value.dialog,
  });
};
export const setScrollPosition = (state, action) => {
  return updateObject(state, { scrollPosition: action.value });
};

export const changeToolbarTheme = (state, action) => {
  return updateObject(state, { OffsetToChangeToolbarTheme: action.value });
};

export const addStackImages = (state, newImage) => {
  var bodyFormData = new FormData();
  if (newImage) {
    bodyFormData.append("image", newImage);
  }
  return updateObject(state, { stack_images: newImage });
};

export const setWindowSize = (state, size) => {
  return updateObject(state, { size });
};

export const toggleLoading = (state, loading) => {
  return updateObject(state, { loading });
};

export const toggleCart = (state, modalCart) => {
  return updateObject(state, { modalCart });
};
